module.exports = __webpack_public_path__ + "img/down.6d3e0b94.svg";